module.exports = __webpack_public_path__ + "static/media/front_phones_3.ab341f09.png";